import { LoyaltyProgramAction, LoyaltyProgramResultType } from '../types';

export const ACTION_MAP_RESULT: Partial<Record<LoyaltyProgramAction, LoyaltyProgramResultType>> = {
  delete: 'deleted',
  publish: 'published',
  unpublish: 'unpublished',
} as const;

export const QR_CODE_IMAGE_WIDTH = 200;
